import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface LineItemsPageProp {
  shipment: Shipment;
}

export function ModifyShipmentLineItemsPage(_props: LineItemsPageProp) {
  return <Heading level={1}>Line Items</Heading>;
}
